import { SVGAttributes } from "react";

function Battery80Icon(props: SVGAttributes<HTMLOrSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M17 5v16c0 .6-.5 1-1 1H8a1 1 0 0 1-1-1V5c0-.6.5-1 1-1h2V2h4v2h2c.6 0 1 .5 1 1zm-2 1H9v4h6V6z" />
    </svg>
  );
}

export default Battery80Icon;
